export enum PartnerNames {
	OKOLO = 'okolo',
	FOODTIME = 'foodtime',
	FRANCHISE = 'franchise',
}
